import * as GLOBAL_CONST from './global';
//import { useDispatch, useSelector } from 'react-redux';
// import {
//   TypeQuestionGroup,
//   TypeSurveyPage,
//   TypeSurveyQuestion,
//   errorValidationType,
//   surveyState,
//   questionVisibilityFilterCondition
// } from "../../survey.types";


export const useValidateVisibilityHook = (surveyData: any) => {

  console.log('surveyData44', surveyData)

  const validateVisibilityRule = (rules: any,surveyData:any) => {
    console.log('surveyData345', surveyData)
    if (rules &&
      GLOBAL_CONST.ConditionType[
      rules.conditionType as keyof typeof GLOBAL_CONST.ConditionType
      ] == "Logical"
    ) {
      return checkLogicalRule(rules);
    } else if (rules &&
      GLOBAL_CONST.ConditionType[
      rules.conditionType as keyof typeof GLOBAL_CONST.ConditionType
      ] == "Compare"
    ) {
      return checkComparison(rules,surveyData);
    }
    return false;
  };

  function getAnswerByQNumber(QNumber: any,surveyData:any) {
    let question: any;
    console.log("QNumber=====", QNumber);
    surveyData?.surveyPages.forEach((pg: any) => {
      console.log("123456",pg)
      // pg.surveyQuestions.forEach((pg: any) => {
        let QObj = pg.surveyQuestions
        .filter((obj: any) => {
          return obj["questionCode"] == QNumber;
        });
        console.log("QObj", QObj);
        if (QObj.length > 0) {
          question = QObj[0];
        }
      // });
    });

    // console.log("question223=====",question)

    // if (question.response instanceof Array) {
    //   return question.response;
    // } else {
    //   return question.responseCode;
    // }
    return question?.response;
  }


  function getQuestionByNumber(QNumber: any,surveyData:any) {
    let question: any;

    surveyData?.surveyPages?.forEach((pg: any) => {

      // pg.surveyQuestions
      // .forEach((pg: any) => {
      //   console.log('surveyData3451', pg)

        let QObj = pg.surveyQuestions
        .filter((obj: any) => {
          return obj["questionCode"] == QNumber;
        });
        if (QObj.length > 0) {
          question = QObj[0];
        }
      // });
      // console.log("pg123",pg)
    });

    return question;
  }

  function checkComparison(fields: any,data:any) {
    console.log("fields",fields)
    let question = getQuestionByNumber(fields.fieldCondition.questionCode,data);
    console.log("checkComparison", question);

    if (
      GLOBAL_CONST.QuestionType[
      question?.questionType as keyof typeof GLOBAL_CONST.QuestionType
      ] == "SingleChoice" ||
      GLOBAL_CONST.QuestionType[
      question?.questionType as keyof typeof GLOBAL_CONST.QuestionType
      ] == "Text"
    ) {
      let answerCode = getAnswerByQNumber(fields.fieldCondition.questionCode,data);
console.log('answerCode', answerCode,fields.fieldCondition.answerCode)
      if (
        GLOBAL_CONST.CompareOperator[
        fields.compareOperator as keyof typeof GLOBAL_CONST.CompareOperator
        ] == "Equal" &&
        answerCode == fields.fieldCondition.answerCode
      ) {

        console.log("Equal");
        console.log(
          "Compare " +
          fields.fieldCondition.questionCode +
          " Answer = " +
          answerCode +
          " == " +
          fields.fieldCondition.answerCode
        );
        return true;
      } else if (
        GLOBAL_CONST.CompareOperator[
        fields.compareOperator as keyof typeof GLOBAL_CONST.CompareOperator
        ] == "NotEqual" &&
        answerCode != fields.fieldCondition.answerCode
      ) {

        console.log("NotEqual");
        console.log(
          "Compare " +
          fields.fieldCondition.questionCode +
          " Answer = " +
          answerCode +
          " != " +
          fields.fieldCondition.answerCode
        );
        return true;
      } else {
        console.log("Compare None");
        return false;
      }
    } else if (
      GLOBAL_CONST.QuestionType[
      question.questionType as keyof typeof GLOBAL_CONST.QuestionType
      ] == "MultiChoice"
    ) {
      let answerArray = getAnswerByQNumber(
        fields.fieldCondition.questionCode,data
      );
      console.log("new arr", answerArray);
      console.log(fields.fieldCondition);
      if (
        GLOBAL_CONST.CompareOperator[
        fields.compareOperator as keyof typeof GLOBAL_CONST.CompareOperator
        ] == "Equal" &&
        checkAnsInArray(fields.fieldCondition.answerCode, answerArray)
      ) {
        console.log(
          "Compare " +
          fields.fieldCondition.questionCode +
          " Answer = " +
          answerArray +
          " IN " +
          fields.fieldCondition.answerCode
        );
        return true;
      } else if (
        GLOBAL_CONST.CompareOperator[
        fields.compareOperator as keyof typeof GLOBAL_CONST.CompareOperator
        ] == "NotEqual" &&
        !checkAnsInArray(fields.fieldCondition.answerCode, answerArray)
      ) {
        console.log(
          "Compare " +
          fields.fieldCondition.questionCode +
          " Answer = " +
          answerArray +
          " NOTIN " +
          fields.fieldCondition.answerCode
        );
        return true;
      } else {
        console.log("Compare None");
        return false;
      }
    }
    return false;
  }

  function checkLogicalRule(fields: any) {
    let conditionBlocks: any = [];
    console.log("checkLogicalRule", fields);
    fields.filterConditions?.forEach((childField: any, Index: number) => {
      if (
        GLOBAL_CONST.ConditionType[
        childField.conditionType as keyof typeof GLOBAL_CONST.ConditionType
        ] == "Compare"
      ) {
        conditionBlocks[Index] = checkComparison(childField);
      } else if (
        GLOBAL_CONST.ConditionType[
        childField.conditionType as keyof typeof GLOBAL_CONST.ConditionType
        ] == "Logical"
      ) {
        conditionBlocks[Index] = checkLogicalRule(childField);
      }
    });
    let conditionStatus = true;
    if (
      GLOBAL_CONST.ConditionOperator[
      fields.conditionOperator as keyof typeof GLOBAL_CONST.ConditionOperator
      ] == "And"
    ) {
      var i;
      conditionStatus = true;
      for (i = 0; i < conditionBlocks.length; i++) {
        if (!conditionBlocks[i]) {
          conditionStatus = false;
        }
      }
    } else if (
      GLOBAL_CONST.ConditionOperator[
      fields.conditionOperator as keyof typeof GLOBAL_CONST.ConditionOperator
      ] == "Or"
    ) {
      var i;
      conditionStatus = false;
      for (i = 0; i < conditionBlocks.length; i++) {
        if (conditionBlocks[i]) {
          conditionStatus = true;
        }
      }
    }
    return conditionStatus;
  }

  function checkAnsInArray(ans: string, arr: any) {
    if (Array.isArray(arr)) {
      let result = arr.includes(ans);
      // let res = arr.filter((obj: any) => {
      //   return obj['value'] == ans && obj['Selected'] == true;
      // }).length;
      // if (res) {
      //   return true;
      // } else {
      //   return false;
      // }
      return result;
    } else {
      return false;
    }
  }

  return validateVisibilityRule

}
